export default {
  paymentDetails: 'Payment details',
  searchPlaceholder: 'Search by name or amount',
  name: 'Name',
  amount: 'Amount',
  terminal: 'Terminal',
  linkedTo: 'linked to',
  noLinked: 'Not linked to any terminal',
  comment: 'Comment for consumer',
  downloadQR: 'Download QR',
  QR: 'QR',
  ID: 'ID',
  addPaymentDetails: 'Add QR code',
  editPaymentDetails: 'Edit "{{name}}"',
  linkTerminal: 'Linked to inactive Terminal. Please activate the terminal first',
};
